import { getLastMonthDayNumber, getMonthName, getMonthNumber, } from '../../../../../../../../utils/dates';
import { getNextShipmentPricingInfo } from '../../../../../../../../utils/nextShipment';
import { replacePropertyInStr } from '../../../../../../../../utils/subscription';
// If the "currentCycle" node does not exist for any reason (it shouldn't happen at this point),
// the default value of the month to show is the current month (opened rolling window).
var DEFAULT_DELIVERY_MONTH = new Date().toISOString();
var useStarterKitShipmentSummary = function (content, subscription) {
    var _a;
    var currentCycle = subscription.currentCycle;
    var currentCycleStartDate = ((_a = currentCycle === null || currentCycle === void 0 ? void 0 : currentCycle.startDate) === null || _a === void 0 ? void 0 : _a.toString()) || DEFAULT_DELIVERY_MONTH;
    var monthName = getMonthName(currentCycleStartDate);
    var deliveryMonth = getMonthNumber(currentCycleStartDate);
    var lastDayMonth = getLastMonthDayNumber(currentCycleStartDate);
    var subtitle = replacePropertyInStr((content === null || content === void 0 ? void 0 : content.subtitle) || '', {
        monthName: monthName,
    });
    var description = replacePropertyInStr((content === null || content === void 0 ? void 0 : content.description) || '', {
        deliveryMonth: deliveryMonth,
        lastDayMonth: lastDayMonth,
    });
    var shipmentPricingInfo = getNextShipmentPricingInfo(subscription);
    return {
        subtitle: subtitle,
        description: description,
        shipmentPricingInfo: shipmentPricingInfo,
    };
};
export default useStarterKitShipmentSummary;
